module.exports = __webpack_public_path__ + "static/media/Senior leaders.7df5d7a8.png";